import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Search, Heart, ShoppingBag, Image } from "lucide-react";
import { useStore } from "../context/StoreContext";

export default function MobileBottomBar() {
  const { cartCount, wishlist } = useStore();
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;

  const Item = ({ to, icon: Icon, label, badge, testid }) => (
    <Link to={to} className="flex flex-col items-center justify-center gap-1 flex-1 py-2 text-navy" data-testid={testid}>
      <div className="relative">
        <Icon size={20} />
        {badge > 0 && <span className="absolute -top-2 -right-2 bg-gold text-white text-[9px] w-4 h-4 flex items-center justify-center rounded-full">{badge}</span>}
      </div>
      <span className="text-[10px] font-medium">{label}</span>
    </Link>
  );

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-ivory border-t border-stone shadow-[0_-1px_0_rgba(198,164,92,0.4)] flex"
         data-testid="mobile-bottom-bar">
      <Item to="/kartini" icon={Image} label="Картини" testid="bottombar-catalog" />
      <Item to="/kartini?focus=search" icon={Search} label="Търсене" testid="bottombar-search" />
      <Item to="/lyubimi" icon={Heart} label="Любими" badge={wishlist.length} testid="bottombar-wishlist" />
      <Item to="/kolichka" icon={ShoppingBag} label="Количка" badge={cartCount} testid="bottombar-cart" />
    </nav>
  );
}
